module.exports = {
      id: "arrow-special-usage",
      viewBox: "0 0 33 14",
      url: __webpack_public_path__ + "img/icons.a0c47b73.svg#arrow-special-usage",
      toString: function () {
        return this.url;
      }
    }